// Shared CSRF token cache used by both apiService and authService so the
// two services don't fight each other over the csrfToken cookie. The token
// is fetched once per session, cached in memory, and refreshed on demand
// (e.g. when the server returns 403 CSRF_TOKEN_INVALID).

const baseURL = process.env.NODE_ENV === 'production'
  ? (process.env.REACT_APP_API_URL || 'https://blp-be.onrender.com')
  : 'http://localhost:5000';

let cachedToken = null;
let inFlight = null;

async function fetchToken() {
  const res = await fetch(`${baseURL}/api/auth/csrf`, {
    credentials: 'include',
  });
  if (!res.ok) {
    throw new Error(`CSRF endpoint returned ${res.status}`);
  }
  const data = await res.json();
  return data.csrfToken;
}

export async function getCsrfToken({ forceRefresh = false } = {}) {
  // Force-refresh clears the cached token and falls through to the normal
  // coalescing path. This way two concurrent forceRefresh calls (e.g. both
  // services hit 403 at the same time) share one fetch + one cookie write,
  // instead of racing each other and ending with a stale cache.
  if (forceRefresh) cachedToken = null;

  if (cachedToken) return cachedToken;
  if (inFlight) return inFlight;

  inFlight = (async () => {
    try {
      cachedToken = await fetchToken();
      return cachedToken;
    } finally {
      inFlight = null;
    }
  })();

  return inFlight;
}

export function clearCsrfToken() {
  cachedToken = null;
  inFlight = null;
}

const csrfTokenCache = {
  getCsrfToken,
  clearCsrfToken,
};

export default csrfTokenCache;
